module.exports = {
  blogPostDir: 'blog', // The name of directory that contains your posts.
  siteTitle: 'Killasser Parish Church', // Site title.
  siteTitleAlt: 'Killasser Parish Church', // Alternative site title for SEO.
  // siteLogo: '/assets/images/logos/ironcove-large-logo.png', // Logo used for SEO and manifest.
  siteUrl: 'https://killasser-parish.netlify.com/about', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-material-starter/.
  // googleTagManagerId: 'GTM-89N8',
  fixedFooter: false, // Whether the footer component is fixed, i.e. always visible
  siteDescription:
    'The online community for the Parish of Killasser. Here you will find interesting facts, photos and forthcoming events about your community.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  // siteFBAppID: '629904053861902', // FB Application ID for using app insights
  // siteGATrackingID: 'UA-20307710-3', // Tracking code ID for google analytics.
  // disqusShortname: 'https-vagr9k-github-io-gatsby-material-starter', // Disqus shortname.
  // postDefaultCategoryID: 'Tech', // Default category for posts.
  // userName: 'Material User', // Username to display in the author segment.
  // userTwitter: 'sandeep8851', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Killasser, Mayo Ireland', // User location to display in the author segment.
  // userAvatar: 'https://api.adorable.io/avatars/150/test.png', // User avatar to display in the author segment.
  userDescription:
    'The online community for the Parish of Killasser. Here you will find interesting facts, photos and forthcoming events about your community.', // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  // userLinks: [
  //   {
  //     label: 'LinkedIn',
  //     url: 'https://www.linkedin.com/company/iron-cove-solutions/',
  //     iconClassName: 'fa fa-linkedin',
  //   },
  //   {
  //     label: 'Google+',
  //     url: 'https://plus.google.com/+Ironcovesolutions',
  //     iconClassName: 'fa fa-google-plus',
  //   },
  //   {
  //     label: 'Tumblr',
  //     url: 'http://ironcovesolutions.tumblr.com/',
  //     iconClassName: 'fa fa-tumblr',
  //   },
  //   {
  //     label: 'Youtube',
  //     url: 'https://www.youtube.com/user/ironcovesolutions',
  //     iconClassName: 'fa fa-youtube',
  //   },
  //   {
  //     label: 'Facebook',
  //     url: 'https://www.facebook.com/IronCoveSolutions',
  //     iconClassName: 'fa fa-facebook',
  //   },
  //   {
  //     label: 'Twitter',
  //     url: 'https://twitter.com/Ironcove',
  //     iconClassName: 'fa fa-twitter',
  //   },
  //   {
  //     label: 'Email',
  //     url: 'sales@ironcovesolutions.com',
  //     iconClassName: 'fa fa-envelope',
  //   },
  // ],
  copyright: 'Copyright © 2018. Killasser Church Parish', // Copyright string for the footer of the website and RSS feed.
}



// WEBPACK FOOTER //
// ./src/data/SiteConfig.js